import { Paper } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import getAllDeploymentDetails from '../../../api/private/deployment/getAllDeploymentDetails';
import DeploymentLogs from './DeploymentLogs';
import CreateNewSchedule from './modals/CreateNewSchedule';
import ReleaseScheduleList from './ReleaseScheduleList';

const useStyles = makeStyles({
  indicator: {
    backgroundColor: '#199fb1 !important', // secondary color
    height: '4px !important',
  },
  selected: {
    color: '#fff !important',
    opacity: '1 !important',
  },
  tabRoot: {
    color: '#fff !important',
    width: '100%',
  },
  table: {
    '& .MuiTableCell-root': {
      paddingTop: '6px',
      paddingBottom: '6px',
    },
  },
  cell: {
    borderRight: '1px solid rgba(224, 224, 224, 1)',
    '&:last-child': {
      borderRight: 'none',
    },
    '&.MuiTableCell-head': {
      backgroundColor: '#fafafa', // grey[100]
    },
    width: '50%',
    '&:first-child': {
      width: '100%',
    },
  },
});

function TabPanel({
  children,
  value,
  index,
  ...other
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.defaultProps = {
  children: {},
  index: 0,
  value: 0,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

function DeploymentScheduleSetting() {
  const styles = useStyles();
  const tabs = ['Schedule', 'History'];
  const [tabValue, setTabValue] = useState(0);
    const [open, setOpen] = useState(false);
  const [nextReleaseDate, setNextReleaseDate] = useState('No Schedule');
  const [reload, setReload] = useState(false);
   const triggerReload = () => setReload((p) => !p);
const now = new Date();
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 0-based months
    const year = date.getFullYear();
    let hours = date.getHours(); // Local time
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12
    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  };
  const getNextReleaseText = (items) => {
    if (items.DeploymentMode === 'Yes' && items.releaseNote !== '') {
      const scheduled = new Date(items.StartTime);
      const currentTime = new Date();
      if (scheduled.getTime() >= currentTime.getTime()) {
        return formatDateTime(items.StartTime);
      }
    }
    return 'No Schedule';
  };
  const handleOnTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const fetchLogs = async () => {
    try {
      await getAllDeploymentDetails(1, 15)
        .then((response) => {
          const nextRow = response.data.Data.filter((item) => item.DeploymentMode === 'Yes')
         .sort((a, b) => new Date(a.StartTime) - new Date(b.StartTime))
          .find((item) => new Date(item.StartTime) > now);
          const result = getNextReleaseText(nextRow);
           setNextReleaseDate(result);
          if (result !== '') {
            setNextReleaseDate(result);
          } else {
            setNextReleaseDate('No Schedule');
          }
        })
        .catch((err) => console.error(err));
    } catch (error) {
      console.error('Error fetching user activity logs:', error);
    }
  };
  const addNewScheduleHandler = async () => {
    setOpen(true);
  };
  useEffect(() => {
    fetchLogs();
  }, []);
  useEffect(() => {
    fetchLogs();
}, [reload]);
  return (
    <Container maxWidth="100%" className="flex flex-col gap-4 my-8">
      <div className="flex flex-col justify-between mb-4 md:mb-8 md:flex-row md:items-center">
        <div>
          <Box px={4} py={2} sx={{ padding: '20px' }}>
            <Typography
              variant="h3"
              sx={{
                color: '#384451',
                marginBottom: 1,
              }}
            >
              Deployment Management
            </Typography>
            <Typography variant="body1" px={0.4} sx={{ marginTop: '-4px' }}>
              Manage Deployment Schedules and Release Notes
            </Typography>
          </Box>
        </div>
        <Stack direction="column" gap={2}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 8,
            }}
          >
            <Paper
              elevation={1}
              sx={{
                borderRadius: '20px',
                padding: 1,
                textAlign: 'center',
                width: 150,
                border: '2px solid #5A9EA8',
                top: 0,
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: '#5A9EA8',
                  fontWeight: 'bold',
                }}
              >
                Next Release
              </Typography>
              <Typography variant="body2">
                {nextReleaseDate}
              </Typography>

            </Paper>
              {open && (
               <CreateNewSchedule
                 open={open}
                 handleClose={() => {
                setOpen(false);
                setReload(true);
          }}
               />
                )}
          </Box>

               <Button
              variant="contained"
              color="primary"
              sx={{
                borderRadius: '20px',
                width: 170,
                height: 40,
                backgroundColor: '#384451',
              }}
              onClick={addNewScheduleHandler}
               >
              + New Schedule
               </Button>
        </Stack>
      </div>
      <section className="w-full">
        <Tabs
          value={tabValue}
          onChange={handleOnTabChange}
          classes={{
            indicator: styles.indicator,
            root: styles.selected,
          }}
          variant="fullWidth"
          scrollButtons="auto"
          allowScrollButtonsMobile
          className="flex flex-row"
          sx={{
            width: '100%',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            overflow: 'hidden',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            backgroundColor: '#384451',
            marginLeft: '19px',
            marginRight: '20px',
          }}
        >
          {tabs.map((tab) => (
            <Tab
              {...a11yProps(tabValue)}
              key={tab}
              label={tab}
              classes={{
                root: styles.tabRoot,
                selected: styles.selected,
              }}
              width="100%"
            />
          ))}
        </Tabs>
        <form className="flex flex-col w-full gap-8">
          <TabPanel value={tabValue} index={0}>
            <ReleaseScheduleList reload={reload} setReload={setReload} onAddSSuccess={triggerReload} />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <DeploymentLogs />
          </TabPanel>
        </form>
      </section>
    </Container>
  );
}

export default DeploymentScheduleSetting;
